import PawnWordSearch from "./PawnWordSearch";
import FootballPictureSlider from "./FootballPictureSlider";
import OfficeCounterXCoordinate from "./OfficeCounterXCoordinate";
import OfficeYCoordinateSudoku from "./OfficeYCoordinateSudoku";
import ASCIIMinesweeper from "./ASCIIMinesweeper";
import CarCircuits from "./CarCircuits";
import GuitarCounterXCoordinate from "./GuitarCounterXCoordinate";
import GuitarCounterYCoordinate from "./GuitarCounterYCoordinate";
import RichPortWeighingScale from "./RichPortWeighingScale";
import HollywoodWeighingScale from "./HollywoodWeighingScale";
import EdgarCryptogram from "./EdgarCryptogram";
import GandhiCryptogram from "./GandhiCryptogram";
import HelenKellerCryptogram from "./HelenKellerCryptogram";
import ForrestGumpCryptogram from "./ForrestGumpCryptogram";
import ShakespeareCryptogram from "./ShakespeareCryptogram";
import ElectricVennDiagram from "./ElectricVennDiagram";
import CesarVennDiagram from "./CesarVennDiagram";
import MapVennDiagram from "./MapVennDiagram";
import StarVennDiagram from "./StarVennDiagram";
import MiddleVennDiagram from "./MiddleVennDiagram";
import SeasonVennDiagram from "./SeasonVennDiagram";
import _1932VennDiagram from "./_1932VennDiagram";

const customComponentsArray = [
  { name: "PawnWordSearch", Component: PawnWordSearch },
  { name: "FootballPictureSlider", Component: FootballPictureSlider },
  { name: "OfficeCounterXCoordinate", Component: OfficeCounterXCoordinate },
  { name: "OfficeYCoordinateSudoku", Component: OfficeYCoordinateSudoku },
  { name: "ASCIIMinesweeper", Component: ASCIIMinesweeper },
  { name: "CarCircuits", Component: CarCircuits },
  { name: "GuitarCounterXCoordinate", Component: GuitarCounterXCoordinate },
  { name: "GuitarCounterYCoordinate", Component: GuitarCounterYCoordinate },
  { name: "RichPortWeighingScale", Component: RichPortWeighingScale },
  { name: "HollywoodWeighingScale", Component: HollywoodWeighingScale },
  { name: "ShakespeareCryptogram", Component: ShakespeareCryptogram },
  { name: "ForrestGumpCryptogram", Component: ForrestGumpCryptogram },
  { name: "HelenKellerCryptogram", Component: HelenKellerCryptogram },
  { name: "GandhiCryptogram", Component: GandhiCryptogram },
  { name: "EdgarCryptogram", Component: EdgarCryptogram },
  { name: "ElectricVennDiagram", Component: ElectricVennDiagram },
  { name: "CesarVennDiagram", Component: CesarVennDiagram },
  { name: "MapVennDiagram", Component: MapVennDiagram },
  { name: "StarVennDiagram", Component: StarVennDiagram },
  { name: "MiddleVennDiagram", Component: MiddleVennDiagram },
  { name: "SeasonVennDiagram", Component: SeasonVennDiagram },
  { name: "_1932VennDiagram", Component: _1932VennDiagram },
];

export default customComponentsArray;
